function getManagedAppName (hasTsgSupport: boolean, getAuthState: () => any, StartupManager: any) {
  return hasTsgSupport
    ? getAuthState?.()?.instances?.get("prisma_access")?.extra?.platform === "onprem"
      ? "prisma_access_panorama"
      : "prisma_access"
    : StartupManager.getManagedAppName();
}

export default getManagedAppName;
